/*!

 =========================================================
 * Material Dashboard PRO React - v1.0.0 based on Material Dashboard PRO - v1.2.0
 =========================================================

 * Product Page: http://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2018 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */

// ##############################
// // // Variables - Styles that are used on more than one component
// #############################
//import { theme } from "../../utils/theme";
const hexToRgb = input => {
  input = input + '';
  input = input.replace('#', '');
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error('input is not a valid hex color.');
  }
  let first = input[0];
  let second = input[1];
  let last = input[2];
  if (input.length === 3) {
    input = first + first + second + second + last + last;
  }

  input = input.toUpperCase(input);
  first = input[0] + input[1];
  second = input[2] + input[3];
  last = input[4] + input[5];
  return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
};

const drawerWidth = 260;
const rightDrawerWidth = 440;
const drawerMiniWidth = 80;

const transition = {
  transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
};

const containerFluid = {
  paddingRight: '15px',
  paddingLeft: '15px',
  marginRight: 'auto',
  marginLeft: 'auto',
  '&:before,&:after': {
    display: 'table',
    content: '" "'
  },
  '&:after': {
    clear: 'both'
  }
};

const container = {
  paddingRight: '15px',
  paddingLeft: '15px',
  marginRight: 'auto',
  marginLeft: 'auto',
  '@media (min-width: 768px)': {
    width: '750px'
  },
  '@media (min-width: 992px)': {
    width: '970px'
  },
  '@media (min-width: 1200px)': {
    width: '1170px'
  },
  '&:before,&:after': {
    display: 'table',
    content: '" "'
  },
  '&:after': {
    clear: 'both'
  }
};

const boxShadow = {
  boxShadow: '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)'
};

const card = theme => ({
  display: 'inline-block',
  position: 'relative',
  width: '100%',
  margin: '10px 0 15px 0',
  boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)',
  borderRadius: '6px',
  color: theme.palette.activeColor,
  background: '#fff',
  overflow: 'visible'
});

const slimPadding = {
  padding: '2px'
};

const primaryColor = theme => theme.palette.timColors?.primary;
const primaryColorRGBA = theme => theme.palette.timColors?.primaryRGBA;
const warningColor = theme => theme.palette.timColors?.warningColor;
const dangerColor = theme => theme.palette.timColors?.dangerColor;

const successColor = theme => theme.palette.timColors?.successColor;
const infoColor = theme => theme.palette.timColors?.infoColor;
const blueColor = theme => theme.palette.timColors?.blueColor;
const roseColor = theme => theme.palette.timColors?.roseColor;
const grayColor = theme => theme.palette.timColors?.grayColor;
//theme colors
const themeColor = theme => theme.palette.timColors?.themeColor;
const themeRGBAColor = theme => theme.palette.timColors?.themeColorRGBA;
const themeShadowRGBAColor = theme => theme.palette.timColors?.themeShadowColorRGBA;

const menuActiveColor = theme => theme.palette.secondary.contrastText;
const menuActiveBkColor = theme => theme.palette.secondary.main;
const menuActiveBk = theme => theme.palette.gradients.secondary;
const menuBkColor = theme => theme.palette.sideMenu?.bgColor;
const menuColor = theme => theme.palette.sideMenu?.color;
const menuBkOpacity = theme => theme.palette.sideMenu?.bgOpacity;
const topBarBkColor = theme => theme.palette.white.main;

const snackInfoBgColor = theme => theme.palette.snackbar?.infoBgColor;
const snackInfoColor = theme => theme.palette.snackbar?.infoColor;
const snackDangerBgColor = theme => theme.palette.snackbar?.dangerBgColor;
const snackDangerColor = theme => theme.palette.snackbar?.dangerColor;
const activeColor = theme => theme.palette.activeColor;
const defaultFont = theme => ({ ...theme.typography.defaultFont });

const primaryBoxShadow = theme => {
  return {
    boxShadow:
      '0 12px 20px -10px ' +
      primaryColorRGBA(theme) +
      ', 0 4px 20px 0px ' +
      primaryColorRGBA(theme) +
      ', 0 7px 8px -5px ' +
      primaryColorRGBA(theme)
  };
};
const infoBoxShadow = {
  boxShadow: '0 12px 20px -10px rgba(0, 188, 212, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 188, 212, 0.2)'
};
const successBoxShadow = {
  boxShadow: '0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2)'
};
const warningBoxShadow = {
  boxShadow: '0 12px 20px -10px rgba(255, 152, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 152, 0, 0.2)'
};
const dangerBoxShadow = {
  boxShadow: '0 12px 20px -10px rgba(244, 67, 54, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(244, 67, 54, 0.2)'
};
const roseBoxShadow = {
  boxShadow: '0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(233, 30, 99, 0.4)'
};
const themeBoxShadow = theme => {
  const RGBAColor = themeRGBAColor(theme);
  return {
    boxShadow: '0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px ' + RGBAColor
  };
};

const themeBoxSecondaryShadow = theme => {
  return { boxShadow: '0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px ' + themeShadowRGBAColor(theme) };
};

const orangeCardHeader = theme => ({
  background: 'linear-gradient(60deg, ' + theme.palette.card.orange400 + ', ' + theme.palette.card.orange500 + ')',
  ...warningBoxShadow
});
const greenCardHeader = theme => ({
  background: 'linear-gradient(60deg, ' + theme.palette.card.green400 + ', ' + theme.palette.card.green500 + ')',
  ...successBoxShadow
});
const redCardHeader = theme => ({
  background: 'linear-gradient(60deg, ' + theme.palette.card.red400 + ', ' + theme.palette.card.red500 + ')',
  ...dangerBoxShadow
});
const blueCardHeader = theme => ({
  background: 'linear-gradient(60deg, ' + theme.palette.card.blue400 + ', ' + theme.palette.card.blue500 + ')',
  ...infoBoxShadow
});
const purpleCardHeader = theme => {
  return {
    background: 'linear-gradient(60deg, #ab47bc, #8e24aa)',
    ...primaryBoxShadow(theme)
  };
};
const roseCardHeader = {
  background: 'linear-gradient(60deg, #ec407a, #d81b60)',
  ...roseBoxShadow
};

const themeCardHeader = theme => {
  const boxShadow = themeBoxShadow(theme);
  const color = themeColor(theme);

  return {
    background: 'linear-gradient(60deg, ' + color + ', ' + color + ')',
    ...boxShadow
  };
};

const cardActions = theme => ({
  margin: '0 20px 10px',
  paddingTop: '10px',
  borderTop: '1px solid #eeeeee',
  height: 'auto',
  ...defaultFont(theme)
});

const cardHeader = {
  margin: '-20px 15px 0',
  borderRadius: '3px',
  padding: '5px'
};

const fontSize2 = {
  fontSize: '2.5vh'
};

const defaultBoxShadow = {
  border: '0',
  borderRadius: '3px',
  boxShadow: '0 10px 20px -12px rgba(0, 0, 0, 0.42), 0 3px 20px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
  padding: '10px 0',
  transition: 'all 150ms ease 0s'
};

const tooltip = {
  padding: '10px 15px',
  minWidth: '130px',
  color: '#FFFFFF',
  lineHeight: '1.7em',
  background: 'rgba(85,85,85,0.9)',
  border: 'none',
  borderRadius: '3px',
  opacity: '1!important',
  boxShadow: '0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)',
  maxWidth: '200px',
  textAlign: 'center',
  fontFamily: defaultFont.fontFamily,
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '400',
  textShadow: 'none',
  textTransform: 'none',
  letterSpacing: 'normal',
  wordBreak: 'normal',
  wordSpacing: 'normal',
  wordWrap: 'normal',
  whiteSpace: 'normal',
  lineBreak: 'auto'
};

const capitalize = {
  textTransform: 'capitalize'
};

export {
  //variables
  hexToRgb,
  drawerWidth,
  rightDrawerWidth,
  drawerMiniWidth,
  transition,
  container,
  containerFluid,
  boxShadow,
  card,
  defaultFont,
  themeColor,
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  blueColor,
  roseColor,
  grayColor,
  primaryBoxShadow,
  infoBoxShadow,
  successBoxShadow,
  warningBoxShadow,
  dangerBoxShadow,
  roseBoxShadow,
  orangeCardHeader,
  greenCardHeader,
  redCardHeader,
  blueCardHeader,
  purpleCardHeader,
  roseCardHeader,
  themeCardHeader,
  themeBoxShadow,
  cardActions,
  cardHeader,
  defaultBoxShadow,
  tooltip,
  slimPadding,
  menuActiveColor,
  menuActiveBkColor,
  menuActiveBk,
  topBarBkColor,
  menuBkColor,
  menuColor,
  menuBkOpacity,
  primaryColorRGBA,
  capitalize,
  snackInfoBgColor,
  snackInfoColor,
  snackDangerBgColor,
  snackDangerColor,
  activeColor,
  themeBoxSecondaryShadow,
  fontSize2
};
